import { getTranspiledConfigsData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useConfigsData = (transpilerId: string, isBulk?: boolean, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getAllConfigsData', transpilerId],
    () => getTranspiledConfigsData(transpilerId, isBulk),
    {
      retry: false,
      refetchOnMount: true,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getAllConfigsData'
    }
  );

  return data;
};
